var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPolygonShape = function SvgPolygonShape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.47 2.214a2.497 2.497 0 0 0-2.94 0L3.343 10.342a2.497 2.497 0 0 0-.908 2.795L6.708 26.29a2.497 2.497 0 0 0 2.377 1.727h13.83a2.497 2.497 0 0 0 2.377-1.727l4.274-13.153a2.497 2.497 0 0 0-.908-2.795L17.469 2.214z",
    fillRule: "evenodd"
  })));
};
export default SvgPolygonShape;